import Bound from "bounds.js"; //スクロールイベントの奴
export default function gnavSticky() {
  boundary.watch(flag, whenGnavEnters, whenGnavLeaves);
}

const flag = document.getElementById(`sticky--flag`);
const target = document.getElementById(`js-gnav-sticky`);
const boundary = new Bound({
  threshold: 0,
  margins: {
    bottom: 0
  }
});

const whenGnavLeaves = ratio => {
  target.classList.add(`is-sticky`);
};

const whenGnavEnters = ratio => {
  target.classList.remove(`is-sticky`);
};
